module.exports = __webpack_public_path__ + "assets/0841e7d271103a66b8b021e95fbd2b90.json";